import "../theme/AdministracionCatalogo.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { useNavigate } from "react-router-dom";
import {TableAdministracionRegistroATB} from "../components/TableAdministracionRegistroATB"
import { useDynamicAuth } from "../context/AuthProviderContext";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const VistaATB = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth();

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a inicio" />
              </div>

              <TableAdministracionRegistroATB />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
